import React, { useCallback, useContext } from "react";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react";
import { UI } from "@wwimmo/ui";
import styles from "./VatProportionField.module.css";

interface IVatProportionFieldProps {
    accountingRowIndex: number;
}

// Vorsteueranteil in % (#24071): free input, no suggestion from the portal. Empty means the ERP books the share
// configured for the realestate / cost center. Only rendered for a VAT code with "proportionally".
const VatProportionFieldBase = (props: IVatProportionFieldProps) => {
    const { t } = useTranslation();
    const { invoiceStore } = useContext(RootStoreContext);
    const { accountingRowIndex } = props;

    const onChangeVatProportionInput = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            invoiceStore.updateAccountingWithVatProportion(e.target.value, accountingRowIndex);
        },
        [invoiceStore, accountingRowIndex]
    );

    return (
        <UI.Input
            label={t("screens.kredi_flow.accountings.vat_proportion").toString()}
            className={styles.VatProportionInput}
            type="text"
            inputMode="decimal"
            autoComplete="off"
            value={invoiceStore.currentInvoice?.getAccountingVatProportion(accountingRowIndex) ?? ""}
            onChange={onChangeVatProportionInput}
        />
    );
};

export const VatProportionField = Sentry.withProfiler(observer(VatProportionFieldBase));
